export function removeSingleRow(params, rows) {
  const newRows = rows.filter((row) => row.$id !== params.id);
  return newRows;
}
